export const complaintDashboardOption = {
	name: [
		{ value: 76, label: "Total Complaint" },
		{ value: 12, label: "Hardware Complaint" },
		{ value: 30, label: "Software Complaint" },
		{ value: 40, label: "Networking Complaint" },
		{ value: 26, label: "Akhil System" },
	],
	title: "Complaint Dashboard",
};
